import React from 'react';
import { BookOpenIcon, MapPinIcon, StarIcon, UsersIcon } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: UsersIcon,
    label: 'Profesionales que ya lo incorporaron'
  }, {
    icon: BookOpenIcon,
    label: '6 módulos + 4 bonos exclusivos'
  }, {
    icon: StarIcon,
    label: '4.9/5 valoración profesional'
  }, {
    icon: MapPinIcon,
    label: 'Desarrollado para Argentina'
  }];
  return <section aria-label="Indicadores del tratado" className="border-b border-white/10 bg-charcoal" data-id="element-172">
      <div className="mx-auto grid max-w-6xl grid-cols-2 divide-x divide-y divide-white/10 md:grid-cols-4 md:divide-y-0" data-id="element-173">
        {stats.map(({
        icon: Icon,
        label
      }) => <div key={label} className="flex min-h-24 flex-col items-center justify-center gap-2 px-4 py-4 text-center" data-id="element-174">
            <Icon size={20} className="text-accent" aria-hidden="true" data-id="element-175" />
            <span className="max-w-[10rem] text-xs font-semibold leading-snug text-stone-200 md:text-sm" data-id="element-176">
              {label}
            </span>
          </div>)}
      </div>
    </section>;
}